"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getNextIdleStatusIn = exports.getNextIdleStatusIn = function getNextIdleStatusIn(idleStatuses) {
  return function (idleStatus) {
    var nextIdleStatusIndex = idleStatuses.indexOf(idleStatus) + 1;
    if (nextIdleStatusIndex < idleStatuses.length) return idleStatuses[nextIdleStatusIndex];
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-idle-monitor/lib/states.js
// module id = 1270
// module chunks = 16